import React from 'react';
import './loader.css'

const Loader = () => {

    return (
        <div>
        <div className="loader__wrap">
            <div className='loader'>
                <div className={`loader-inner`}>

                </div>
            </div>
        </div>
        </div>
    )
}

export default Loader
